/* @jsxImportSource react */

import type { ReactNode } from 'react';

import { type Language } from '@packages/config';
import type { LinkProps } from '../../../../Link/Link';
import { Link } from '../../../../Link/Link';
import type { SlotPriority } from './types';

export type SlotLinkProps = {
  label?: string;
  /** Accessible name for the link, defaults to `label` */
  ariaLabel?: string;
  href: string;
  language?: Language;
  children: ReactNode;
  priority: SlotPriority;
  isBusy?: boolean;
};

/**
 * Simplified version of the legacy Slot, for cases where the slot just needs to be a link
 *
 * @param children The icon for the slot, should be sized 32x32 pixels (w-4 h-4)
 * @param label The text label (and accessible label) for the slot
 * @param href The URL to link to
 */
export const SlotLink = ({
  label,
  ariaLabel,
  href,
  language,
  children,
  priority,
  onClick,
  isBusy = false,
}: SlotLinkProps & Pick<LinkProps, 'onClick'>) => (
  <Link
    href={href}
    language={language}
    aria-label={ariaLabel ?? label}
    aria-busy={isBusy ? 'true' : undefined}
    aria-disabled={isBusy ? 'true' : undefined}
    className={`slot-mobile-priority-${priority} slot-link ${isBusy ? 'pointer-events-none opacity-50' : ''} hover:text-color-primary hover:after:bg-color-primary relative flex flex-col items-center py-0.5 hover:after:pointer-events-none hover:after:absolute hover:after:inset-0 hover:after:top-auto hover:after:h-[2px]`}
    onClick={isBusy ? undefined : onClick}
  >
    {children}
    <span className="text-size-body-xs text-center hyphens-auto max-lg:hidden">{label}</span>
  </Link>
);
